// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M_xwT","fullView":"styles_fullView__2Mmbv"};